import { useEffect, useState } from "react";
import { OPTION_ACCOUNT_CANCELLATION_ACCOUNT } from 'constants/accounts';
import { ACTION_BUTTON_FLOWS, ACTION_BUTTON_TRANSFER_FLOW, ACTION_BUTTON_FIOC_FLOW, ACTION_BUTTON_DNI_FLOW } from '../constants/account';
import {
    taggingCloseEvent,
    taggingCancelEvent,
    taggingRedirectToTransferEvent,
    taggingUnderstoodEvent,
    taggingOpenEvent,
    taggingRedirectToFiocEvent,
    taggingRedirectToIDEvent
} from "../helpers/tagging";

export const useModalValidation = ({ immAccountValidation, history, accountId, optionSelected, resetAction }) => {
    const [openModal, setOpenModal] = useState(false);
    
    const isServiceFailed = immAccountValidation.get('isError');
    const isValidationSuccess = immAccountValidation.get('isSuccess');
    const isRequieredAction = immAccountValidation.get('isInvalid');

    useEffect(() => {
        const isOpenModal = isRequieredAction || isValidationSuccess || isServiceFailed;
        setOpenModal(isOpenModal);

        isOpenModal && taggingOpenEvent(immAccountValidation)
    }, [immAccountValidation, optionSelected])

    const handleCancel = () => {
        resetAction();
    }

    const handleActionsRedirection = () => {
        const { navigationFlowConfirmationButton } = getValidationMessage(immAccountValidation);
        let url = '';

        if (navigationFlowConfirmationButton === ACTION_BUTTON_TRANSFER_FLOW) {
            url =  ACTION_BUTTON_FLOWS[ACTION_BUTTON_TRANSFER_FLOW];
            taggingRedirectToTransferEvent(immAccountValidation)
        }

        if (navigationFlowConfirmationButton === ACTION_BUTTON_FIOC_FLOW) {
            url = ACTION_BUTTON_FLOWS[ACTION_BUTTON_FIOC_FLOW];
            taggingRedirectToFiocEvent(immAccountValidation)
        }

        if (navigationFlowConfirmationButton === ACTION_BUTTON_DNI_FLOW) {
            url = ACTION_BUTTON_FLOWS[ACTION_BUTTON_DNI_FLOW];
            taggingRedirectToIDEvent(immAccountValidation)
        }

        if (!url) {
            taggingUnderstoodEvent(immAccountValidation);
            return handleCancel();
        }

        history.push(url);
    }

    const handleOwnerFlowRedirection = () => {
        if (optionSelected === OPTION_ACCOUNT_CANCELLATION_ACCOUNT) {
            history.push(`/myprofile/accounts/${accountId}/cancel`);
        }
        resetAction();
    }

    const handlePrimaryButtonAction = () => {
        if (isRequieredAction) {
            handleActionsRedirection();
            return;
        }
        handleOwnerFlowRedirection()
    }

    const handleCloseModal = () => {
        setOpenModal(false);
        resetAction();
    }

    const handleCloseModalWrapper = (isCloseButton) => {
        isCloseButton
            ? taggingCloseEvent(immAccountValidation)
            : taggingCancelEvent(immAccountValidation)
        handleCloseModal()
    }

    const getValidationMessage = () => {
        if (isValidationSuccess) { return {} }

        const validationMessage = immAccountValidation.get('validationMessage');
        return {
            titleText: validationMessage.get('titleText'),
            descriptionText: validationMessage.get('descriptionText'),
            buttonText: validationMessage.get('buttonText'),
            navigationFlowConfirmationButton: validationMessage.get('navigationFlowConfirmationButton')
        };
    }

    return {
        openModal,
        isServiceFailed,
        handlePrimaryButtonAction,
        handleCancel: handleCloseModalWrapper,
        getValidationMessage,
    }
}
